import { bannerSlider } from "@omni/ui/brand/bannerSlider/bannerSlider.styles";
import { Button as ButtonBase } from "@omni/ui/components/Button/button.component";

import { useBannerSliderContext } from "@/components/BannerSlider/context/bannerSlider.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { TimerStatus } from "@/utils/hooks/timer/useTimer.types";
import { useClickTracking } from "@/utils/hooks/tracking/useClickTracking.hook";

type Props = {
    className?: string;
};

export const Button = ({ className }: Props) => {
    const { t } = useGranite();

    const { status, stopTimer, startTimer } = useBannerSliderContext();

    const { trackingProps } = useBannerSliderContext();

    const isPaused = status === TimerStatus.Stopped;
    const isRunning =
        status === TimerStatus.Running || status === TimerStatus.Initial;

    const { onClick } = useClickTracking({
        "button-click": {
            name: `banner-slider-${isPaused ? "play" : "pause"}`,
            category: trackingProps["banner-slide-click"]?.category || "",
            placement: trackingProps["banner-slide-click"]?.placement
        }
    });

    const { controls_button, controls_button_icon } = bannerSlider();

    return (
        <ButtonBase
            size={"sm"}
            color={"primary"}
            className={controls_button({ className })}
            aria-label={t(
                `general.bannerSlider.progressBar.toggle.${isPaused ? "play" : "pause"}`
            )}
            outline={true}
            onClick={(e) => {
                onClick(e);
                switch (status) {
                    case TimerStatus.Running:
                        stopTimer();
                        break;
                    case TimerStatus.Stopped:
                        startTimer();
                        break;
                    default:
                        break;
                }
            }}
        >
            <i className={controls_button_icon({ isRunning: isRunning })} />
        </ButtonBase>
    );
};
